import { useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { ICompanyMemberRequest } from '@/features/company-members/store/models/company-members.model';
import { getUserChildren } from '@/features/company-members/store/actions/company-members.actions';
import { useCompanyMembers } from '@/features/company-members/hooks/useCompanyMembers';
import { CompanyMemberFilter } from '@/features/company-members/components/CompanyMemberFilter';
import { CompanyMemberTable } from '@/features/company-members/components/CompanyMemberTable';

import { useAppDispatch } from '@/hooks/redux-helpers';

interface IFilterForm {
  pageNumber: number;
  name: string;
  userId: string;
  status: string[];
}

export function CompanyMemberList() {
  const { user } = useCompanyMembers();

  const methods = useForm<IFilterForm>({
    defaultValues: {
      pageNumber: 0,
      name: '',
      userId: '',
      status: [],
    },
  });

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getUserChildren({ parentUserId: user.userId }));
  }, [dispatch, user.userId]);

  const onFilter = useCallback(
    (filterProps: Omit<ICompanyMemberRequest, 'parentUserId'>) =>
      dispatch(getUserChildren({ parentUserId: user.userId, ...filterProps })),
    [dispatch, user.userId],
  );

  const onPageChange = useCallback(
    (pageNumber: number) => {
      methods.setValue('pageNumber', pageNumber);
      const { status, ...filterProps } = methods.getValues();
      onFilter({
        ...filterProps,
        pageNumber: pageNumber + 1,
      });
    },
    [methods, onFilter],
  );

  return (
    <FormProvider {...methods}>
      <div className="flex flex-col gap-6">
        <CompanyMemberFilter onFilter={onFilter} />
        <CompanyMemberTable onPageChange={onPageChange} />
      </div>
    </FormProvider>
  );
}
export default CompanyMemberList;
